import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Megaphone({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M560 96C551.2 96 544 103.2 544 112L544 129L96 255L96 240C96 231.2 88.8 224 80 224C71.2 224 64 231.2 64 240L64 400C64 408.8 71.2 416 80 416C88.8 416 96 408.8 96 400L96 385L198.3 413.8C194.2 424.4 192 436 192 448C192 501 235 544 288 544C335 544 374.2 510.2 382.4 465.5L544 511L544 528C544 536.8 551.2 544 560 544C568.8 544 576 536.8 576 528L576 112C576 103.2 568.8 96 560 96zM544 477.8L96 351.8L96 288.3L544 162.3L544 477.8zM351.4 456.8C347.1 488 320.4 512 288 512C252.7 512 224 483.3 224 448C224 438.9 225.9 430.3 229.3 422.5L351.4 456.8z" />
    </svg>
  );
}
